import {
    TFormalOffer,
    TFormalOfferVariationType,
    TFormalOfferVariationTrees
} from './formalOffers.types';
import { isFormalOfferVariationType } from './isFormalOfferVariationType';

/**
 * Finds the variation offer and its type for a given selected offer.
 *
 * @param formalOffers The list of formal offers.
 * @param variationTrees The formal offer variation relationship trees.
 * @param selectedOffer The currently selected formal offer.
 * @returns The varied offer and its variation type, or `null` if no valid variation exists.
 */
export const getSelectedOfferVariation = (
    formalOffers: TFormalOffer[],
    variationTrees: TFormalOfferVariationTrees,
    selectedOffer: TFormalOffer | undefined
): {
    variedOffer: TFormalOffer;
    variationType: TFormalOfferVariationType;
} | null => {
    if (!selectedOffer) return null;

    const variation = variationTrees.find(
        (tree) => tree.base_formal_offer_id === selectedOffer.formal_offer_id
    )?.variations[0];

    if (!variation || !isFormalOfferVariationType(variation.variation_type)) {
        return null;
    }

    const variedOffer = formalOffers.find(
        (offer) => offer.formal_offer_id === variation.formal_offer_id
    );

    if (!variedOffer) return null;

    return {
        variedOffer,
        variationType: variation.variation_type
    };
};
